import { create } from "qrcode/lib/core/qrcode";
import React from "react";
import { View } from "react-native";

export function ReferralQr({ value }: { value: string }) {
  const qr = create(value, { errorCorrectionLevel: "M" });
  const size = qr.modules.size;
  const cell = 4;

  return (
    <View style={{ backgroundColor: "#fff", padding: 8 }}>
      {Array.from({ length: size }, (_, y) => (
        <View key={y} style={{ flexDirection: "row" }}>
          {Array.from({ length: size }, (_, x) => (
            <View
              key={x}
              style={{
                width: cell,
                height: cell,
                backgroundColor: qr.modules.get(y, x) ? "#111827" : "#ffffff",
              }}
            />
          ))}
        </View>
      ))}
    </View>
  );
}
